/**
 * Continuous (Dauertermin) day view — SIBLING of standardDay.ts, per the
 * builder rule documented there: one pure module per view mode, never a
 * branch inside another builder. The engine stays ignorant of what a
 * "Dauertermin" is; from its perspective the columns are just resources and
 * the events happen to carry weekly `daysOfWeek` recurrence, which its index
 * already understands.
 *
 * Differences from the standard builder, both deliberate:
 *  - No patient-column filter: the continuous controller never produces the
 *    legacy synthetic column in the first place.
 *  - The blocked band uses WEEKLY availability blocks only. This view is a
 *    weekly template ("every Tuesday"), so date-specific blocking slots (a
 *    concrete vacation week) don't belong — they describe dates, not
 *    weekdays, and painting them here would claim a permanent conflict where
 *    a temporary one exists.
 */
import { PatientAvailabilityDto } from "../../../api-client";
import {
  CalendarEvent,
  CalendarResource,
} from "../../Calendar/controller/adapters/types";
import { buildPatientBlockedRanges } from "../model/patientAvailability";
import { MCGridConfig, MCTimeRange } from "../model/types";

export interface ContinuousDayInput {
  resources: CalendarResource[];
  events: CalendarEvent[];
  date: Date;
  patientAvailabilities: ReadonlyArray<PatientAvailabilityDto> | undefined;
  cfg: Pick<MCGridConfig, "dayStartMin" | "dayEndMin">;
}

export interface ContinuousDayViewModel {
  resources: CalendarResource[];
  events: CalendarEvent[];
  patientBlockedRanges: MCTimeRange[];
}

export const buildContinuousDayViewModel = ({
  resources,
  events,
  date,
  patientAvailabilities,
  cfg,
}: ContinuousDayInput): ContinuousDayViewModel => ({
  resources,
  events,
  patientBlockedRanges: buildPatientBlockedRanges({
    availabilities: patientAvailabilities,
    blockingSlots: undefined,
    date,
    cfg,
  }),
});
